export default {"src":"/_next/static/media/home-safety-purple.af772466.svg","height":149,"width":200,"blurWidth":0,"blurHeight":0};